import type { IGalleryPhoto } from '../constants/sensorGalleryType';
import { getFilteredImages } from './getFilteredImages';

export const getIsMainAssetExist = (
  images: { images: IGalleryPhoto[]; uploadedImages: IGalleryPhoto[] },
  deletedPhotoIds: (number | string)[],
) => {
  const filteredImages = getFilteredImages(images.images, deletedPhotoIds);
  const filteredUploadedImages = getFilteredImages(images.uploadedImages, deletedPhotoIds);

  const isMainAssetAtSavedPhotos = !!filteredImages.find((img) => img.imageType === 'primaryImage');
  const isMainAssetAtUploadedPhotos = !!filteredUploadedImages.find(
    (img) => img.imageType === 'primaryImage',
  );

  if (!filteredImages.length && !filteredUploadedImages.length) {
    return true;
  }

  return isMainAssetAtSavedPhotos || isMainAssetAtUploadedPhotos;
};
